import React from 'react';

import { ContentRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { ProfileLiteRelayDto } from '@diritto/common/relay/dtos/profile-lite-relay.dtos';
import { SectionContentDto, SectionRankDto } from '@diritto/common/relay/dtos/section-relay.dtos';
import { TrackerExtraInfoProps } from '@diritto/common/tracker/tracking-event.constant';
import { SectionContentTextsBase } from 'app-components/home/sections/components/SectionContentTextsBase';
import { SectionContentLiteTextItem } from 'app-components/home/sections/items/SectionContentLiteTextItem';

type SectionProps = {
  section: SectionContentDto | SectionRankDto;
  contents: Record<number, ContentRelayDto>;
  profileLites: Record<number, ProfileLiteRelayDto>;
};

const ITEMS_PER_COLUMN = 5;

export const SectionContentLiteTexts = ({
  section,
  contents,
  profileLites,
  trackerExtraInfo,
}: SectionProps & TrackerExtraInfoProps) => (
  <SectionContentTextsBase
    section={section}
    contents={contents}
    profileLites={profileLites}
    trackerExtraInfo={trackerExtraInfo}
    itemsPerColumn={ITEMS_PER_COLUMN}
    ItemComponent={SectionContentLiteTextItem}
  />
);

export default SectionContentLiteTexts;
